import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorCtProfitShare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M7.072 14.958a8.5 8.5 0 1 1 14.627-.797c.066.01.132.024.198.04 1.65.412 2.192 2.485.956 3.653l-4.555 4.302a4.374 4.374 0 0 1-3.003 1.194H2.2a.75.75 0 0 1 0-1.5h13.095c.734 0 1.44-.28 1.973-.785l4.555-4.302a.652.652 0 0 0-.846-.991l-4.3 3.308a1.75 1.75 0 0 1-1.067.363h-5.16a.75.75 0 0 1 0-1.5h4.055a.767.767 0 0 1 .05-.079.99.99 0 0 0-.806-1.564H8.166a2.362 2.362 0 0 0-2.292 1.79 1.787 1.787 0 0 1-1.734 1.353H2.2a.75.75 0 0 1 0-1.5h1.94c.132 0 .247-.09.279-.218a3.863 3.863 0 0 1 2.653-2.767Zm.078-4.708a6.97 6.97 0 0 0 1.68 4.55h4.92c1.557 0 2.613 1.355 2.482 2.73l2.332-1.794a.75.75 0 0 1 .153-.18A7 7 0 1 0 7.15 10.25Z"
    />
    <path
      fill="#F7A600"
      d="m14.218 6 .091.55a4.185 4.185 0 0 0 3.307 3.415 4.185 4.185 0 0 0-3.307 3.415l-.091.55-.088-.526a4.226 4.226 0 0 0-3.31-3.439 4.185 4.185 0 0 0 3.306-3.415l.092-.55Z"
    />
  </svg>
);
export default SvgTwoColorCtProfitShare;
